import React, { useState } from 'react';
import PropTypes from 'prop-types';
import LocalizedLink from 'helpers/LocalizeLink';
import Picture from 'components/elements/Picture';

function CartBoxWidget(props) {
    const [underLine, setUnderLine] = useState(0);

    if (!props?.items) return null;

    return (
        <div data-test-id="features-wr" className={"widget widget-cartbox" + (props?.dark ? " bg-dark" : "")}>
            <div className="container-xl row mx-auto p-0">
                {
                    props?.items?
                    props.items.map((item, index) => {
                        if (!item) return null
                        return (
                            <div key={index} className="card col-lg-4 col-md-6 col-sm-12 text-center mb-72 mb-sm-40">
                                {
                                    item?.img?.source || item?.img_mob?.source ?
                                        <div
                                            onMouseEnter={() => { setUnderLine(index + 1) }}
                                            onMouseLeave={() => { setUnderLine(0) }}
                                        >
                                            <Picture dti={"features-img-" + index} img={item.img} img_mob={item.img_mob} />
                                        </div>
                                        : null
                                }
                                {
                                    item?.url ?
                                        ((item.url.startsWith("https://") || item.url.startsWith("http://")) ?
                                            <a data-test-id={"features-title-link-" + index} href={item.url} className='text-decoration-none'><h3 data-test-id={"features-title-" + index} className={"card-title d-flex justify-content-center align-items-center my-2" + (index + 1 === underLine ? " text-underline" : "")}>{item.title}</h3></a> :
                                            <LocalizedLink to={item.url} dti={"features-title-link-" + index}>
                                                <h3 data-test-id={"features-title-" + index} className={(props?.dark ? "text-white " : "") + "card-title d-flex justify-content-center align-items-center my-2" + (index + 1 === underLine ? " text-underline" : "")}>{item.title}</h3>
                                            </LocalizedLink>) :
                                            <h3 data-test-id={"features-title-" + index} className={(props?.dark ? "text-white " : "") + "card-title d-flex justify-content-center align-items-center my-2" + (index + 1 === underLine ? " text-underline" : "")}>{item.title}</h3>
                                }
                                {
                                    item?.descriptions ?
                                        <p data-test-id={"features-description-" + index} className={(props?.dark ? "text-white " : "") + "card-text text-small text-justify"} title={item.descriptions}>{item.descriptions}</p>
                                        : null
                                }
                            </div>
                        )
                    }):null
                }
            </div>
        </div>
    )
}

CartBoxWidget.propTypes = {
    title: PropTypes.string,
    descriptions: PropTypes.string,
    additional_text: PropTypes.string,
    button_text: PropTypes.string,
    path: PropTypes.string,
    img: PropTypes.string,
    position: PropTypes.string,
    widget: PropTypes.string,
    className: PropTypes.string,
    items: PropTypes.array,
}

export default CartBoxWidget;
